import React, { PropTypes, Component } from 'react'
import classes from './Heading.scss'

class Heading extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    withSearchbox: PropTypes.bool,
    left: PropTypes.bool
  }

  render () {
    const { children, left, withSearchbox } = this.props
    return (
      <h1 className={`${classes.heading} ${withSearchbox && classes.withSearchbox} ${left && classes.left}`}>
        {children}
      </h1>
    )
  }
}

export default Heading



/** WEBPACK FOOTER **
 ** ./src/components/Heading.js
 **/